import { useState, useEffect, useRef } from 'react';
import { SkeletonScene } from './SkeletonLoader';

const MainContent = ({ activeOverlay, activeView, kitchenView, vanityView, wallView, cabinetColor, upperCab, lowerCab, sceneLikeBtn }) => {
  const [sceneLoaded, setSceneLoaded] = useState(false);
  const baseImgRef = useRef(null);

  // Skeleton stays up until the real-life base photo has actually loaded.
  // A safety-net timeout only guards against onLoad never firing (e.g. load error).
  useEffect(() => {
    setSceneLoaded(false);
    if (baseImgRef.current && baseImgRef.current.complete) {
      setSceneLoaded(true);
    }
    const timeout = setTimeout(() => {
      setSceneLoaded(true);
    }, 6000);
    return () => clearTimeout(timeout);
  }, [activeView, kitchenView, vanityView, wallView, cabinetColor, lowerCab, upperCab]);

  const getOverlayImage = () => {
    switch (activeView) {
      case 'Kitchens':
        switch (kitchenView) {
          case 1:
            if (cabinetColor === 'W') return '/mainpng-white.png';
            return cabinetColor ? `/mainpng2-${cabinetColor}.png` : '/mainpng2.png';
          case 2:
            return '/mainpng.png';
          case 3:
            return '/mainpng3.png';
          default:
            return '/mainpng.png';
        }
      case 'Vanities':
        switch (vanityView) {
          case 1:
            return '/mainvanitiespng.png';
          case 2:
            return '/mainvanitiespng1.png';
          case 3:
            return '/mainvanitiespng2.png';
          default:
            return '/mainvanitiespng.png';
        }
      case 'Wall-cladding':
        switch (wallView) {
          case 1:
            return '/mainwallcladding.png';
          case 2:
            return '/mainwallcladding1.png';
          case 3:
            return '/mainwallcladding2.png';
          case 4:
            return '/mainwallcladding3.png';
          default:
            return '/mainwallcladding.png';
        }
      default:
        return '/mainpng.png';
    }
  };

  const isTwoTone = cabinetColor === '2T' && activeView === 'Kitchens' && kitchenView === 1;

  // For 2-tone: use the lower cabinet colour as the full-scene base (covers everything),
  // then overlay only the upper cabinet layer on top — no gap, no original bleed-through.
  // lowerCab is a scene ID: '', 'B', 'BL', 'CR', 'G'
  const twoToneBase = lowerCab === 'W' ? '/mainpng-white.png' : lowerCab ? `/mainpng2-${lowerCab}.png` : '/mainpng2.png';

  // upperCab scene ID → upper overlay filename
  const upperImageMap = {
    '':   '/mainpng2-upper.png',
    'CR': '/mainpng2-CR-upper.png',
    'G':  '/upper-green.png',
    'BL': '/upper-black.png',
    'B':  '/mainpng2-B-upper.png',
    'W':  '/mainpng2-white-upper.png',
  };
  const upperImage = upperImageMap[upperCab] || '/mainpng2-upper.png';

  return (
    <div className="main-content">
      <SkeletonScene hidden={sceneLoaded} />
      {activeOverlay && (
        <img
          src={activeOverlay}
          alt="Base"
          className="main-image"
          style={sceneLoaded ? undefined : { opacity: 0 }}
        />
      )}
      <img
        ref={baseImgRef}
        src={isTwoTone ? twoToneBase : getOverlayImage()}
        alt={`${activeView} Overlay`}
        className="overlay-image visible"
        onLoad={() => setSceneLoaded(true)}
        style={sceneLoaded ? undefined : { opacity: 0 }}
      />
      {isTwoTone && (
        <img
          src={upperImage}
          alt="Upper cabinets"
          className="overlay-image visible"
        />
      )}
      {sceneLikeBtn}
    </div>
  );
};

export default MainContent; 